const Footer = () => {

    return(
    <div className="footer register-footer text-center">
        <h6>
        <div className="copyright">
            © {new Date().getFullYear()}{" "}
            Macedonian Stock Exchange
        </div>
        </h6>
    </div>)
};

export default Footer;